/* globals console, module, require */
/* jshint esversion:6, globalstrict:true */
'use strict';

const jQuery = require('jquery'),
    _ = require('lodash'),
    configuration = require('./configuration'),
    excludedTipCodes = {
        vacancyStatusTypeRetired: true
    },
    propertyToEnumerationKey = {
        accessibilityTypeIds:        'AccessibilityType',
        bathroomTypeId:              'BathroomType',
        buildingAccessTypeIds:       'BuildingAccessType',
        canServeMAWaiversTypeIds:    'CanServeMAWaiversType',
        countyId:                    'County',
        criminalBackgroundTypeIds:   'CriminalBackgroundType',
        householdTypeIds:            'HouseholdType',
        incomeSupportTypeIds:        'IncomeSupportType',
        kitchenTypeId:               'KitchenType',
        languagesSpokenTypeIds:      'LanguagesSpokenType',
        mealsServedTypeId:           'MealsServedType',
        medicationServicesTypeIds:   'MedicationServicesType',
        organizationRoleTypeId:      'OrganizationRoleType',
        organizationStatusTypeId:    'OrganizationStatusType',
        parkingTypeId:               'ParkingType',
        petPolicyTypeIds:            'PetPolicyType',
        programRoleTypeId:           'ProgramRoleType',
        programStatusTypeId:         'ProgramStatusType',
        programTypeId:               'ProgramType',
        religionActivityTypeIds:     'ReligionActivityType',
        serviceForDiagnosisTypeIds:  'ServiceForDiagnosisType',
        serviceOnSiteTypeIds:        'ServiceOnSiteType',
        serviceParticipationTypeIds: 'ServiceParticipationType',
        siteTypeId:                  'SiteType',
        smokingPolicyTypeId:         'SmokingPolicyType',
        sobrietyPeriodTypeId:        'SobrietyPeriodType',
        sobrietyPolicyTypeId:        'SobrietyPolicyType',
        targetPopulationTypeIds:     'TargetPopulationType',
        unitCategoryTypeId:          'UnitCategoryType',
        unitStatusTypeId:            'UnitStatusType',
        vacancyStatusTypeId:         'VacancyStatusType',
        vacancyFillReasonTypeId:     'VacancyFillReasonType',
        visitorPolicyTypeId:         'VisitorPolicyType'
    },
    lowerCaseify = {
        //'County': true // safeguard against mismatches between capitalization in our county tip codes and google's county names
    },
    // url = 'builds/enumerations.json';
    url = configuration.mockdata.enumerations ? '/mockdata/enumerations.json' : configuration.apiUrlBase + 'enumerations';


module.exports = {
    initialize: function (callback) {
        jQuery.getJSON(url, _.bind(function (enumerations) {
            const e = {},
                cv = {};
            _.each(propertyToEnumerationKey, function (key, property) {
                if (!e[property]) {
                    e[property] = {};
                }
                if (key) {
                    _.each(enumerations[key], function (item) {
                        if (!excludedTipCodes[item.tipCode]) {
                            e[property][item.id] = {
                                code: lowerCaseify[key] ? item.tipCode.toLowerCase() : item.tipCode,
                                order: item.order
                            };
                            cv[lowerCaseify[propertyToEnumerationKey] ? item.tipCode.toLowerCase() : item.tipCode] = item.id;
                        }
                    });
                }
            });
            _.extend(this.enumerations, e);
            _.extend(this.codeValues, cv);
            if (callback) { callback(null); }
        }, this));
    },
    enumerations: {},
    codeValues: {}
};
